import { render, staticRenderFns } from "./CieloQRCode.vue?vue&type=template&id=18b6ec28"
import script from "./CieloQRCode.vue?vue&type=script&lang=js"
export * from "./CieloQRCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports